import React from 'react';
import {
  Formik,
  Field,
} from 'formik';
import * as Yup from 'yup';

import {
  Flex,
} from 'web-styled';
import {
  Modal,
  Button,
  TextField,
  ThreeFolders,
} from 'web-components';

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required'),
});

type Props = {
  label: string;
  isOpen: boolean;
  folderName: string;
  appearance?: string;
  closeButton: boolean;
  buttonLabel: string;
  onSubmit: { (data: any, actions: any): void };
  onRequestClose: { (): void };
};

const AddEntity = ({
  label,
  buttonLabel,
  appearance,
  folderName,
  closeButton,
  isOpen,
  onSubmit,
  onRequestClose,
}: Props) => (
  <Modal
    title={label}
    isOpen={isOpen}
    onRequestClose={onRequestClose}
  >
    <Formik
      validateOnBlur={false}
      validationSchema={validationSchema}
      initialValues={{
        name: '',
      }}
      onSubmit={onSubmit}
    >
      {({
        values,
        setFieldValue,
        handleSubmit,
        isSubmitting,
      }) => (
        <Flex
          column
          width="100%"
          as="form"
          spacing={15}
          onSubmit={handleSubmit}
        >
          <Field
            autoFocus
            name="name"
            label="Enter name"
            component={TextField}
          />
          {folderName && (
            <ThreeFolders
              selectedId={values.folder_id}
              folderName={folderName}
              onSelect={(id) => {
                setFieldValue('folder_id', id);
              }}
            />
          )}
          <Flex
            width="100%"
            justify={closeButton ? 'center' : 'flex-end'}
            spacing={20}
          >
            {closeButton && (
              <Button
                ghost
                appearance="danger"
                spacing="large"
                onClick={onRequestClose}
              >
                Close
              </Button>
            )}
            <Button
              ghost
              appearance={appearance || 'primary'}
              type="submit"
              spacing="large"
              isLoading={isSubmitting}
              isDisabled={isSubmitting}
            >
              {buttonLabel}
            </Button>
          </Flex>
        </Flex>
      )}
    </Formik>
  </Modal>
);

AddEntity.defaultProps = {
  appearance: 'primary',
};

export default AddEntity;
